export class ThinningAndHarvestYield {
  id: number;
  siteCurveId: number;
  harvestEvent: string;
  yieldKey: string;
  largeSawlogs: number;
  smallSawlogs: number;
  posts: number;
  pulplogs: number;

  constructor() {
    this.id = 0;
    this.siteCurveId = 0;
    this.harvestEvent = '';
    this.yieldKey = '';
    this.largeSawlogs = 0;
    this.smallSawlogs = 0;
    this.posts = 0;
    this.pulplogs = 0;
  }

  public static getDummyHarvestAndYield(): ThinningAndHarvestYield {
    return new ThinningAndHarvestYield();
  }
}
